import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 100 100"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M81.444 49.646H60.687v5.151h13.578c-1.01 7.1-7.037 11.72-14.624 11.72-2.676 0-5.122-.514-7.25-1.47 3.51-3.824 5.478-8.957 5.478-14.958 0-6.002-1.88-11.118-5.282-14.906 2.18-1.044 4.661-1.629 7.32-1.629h.514c6.63.018 10.884 4.054 12.727 6.25.674.814 1.029 1.38 1.029 1.38l5.034-2.602s-.39-.85-1.259-2.09a21.4 21.4 0 0 0-4.343-4.602c-2.96-2.301-7.179-4.32-12.975-4.32h-.709c-4.68 0-8.97 1.258-12.567 3.453-4.024-2.302-9.04-3.523-14.855-3.523H18.5v45h14.836c5.3 0 9.962-1.168 13.756-3.31 3.687 2.106 8.047 3.31 12.337 3.31 6.505 0 13.347-2.78 17.265-7.347 3.314-3.806 5.158-7.54 4.75-15.507m-37.933.655c0-4.266 1.383-8.055 3.74-10.958 2.41 2.762 3.723 6.373 3.723 10.64 0 4.567-1.33 8.302-3.83 11.063-2.321-2.743-3.633-6.426-3.633-10.745M31.369 66.694h-6.01v-33.37h6.01c4.112 0 7.71.744 10.653 2.16-3.492 4.036-5.548 9.311-5.548 15.224S38.21 61.1 41.668 64.87c-2.854 1.204-6.293 1.823-10.3 1.823"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }